
export const ErrorAlert = ( { errorMessage } ) => (
	<p className="soo-alert -error" role="alert">{errorMessage}</p>
);
